import { lowerCase } from "change-case-all";
import { useNavigate } from "react-router-dom";
import { Visibility } from "@mui/icons-material";
import { Grid, Tooltip, Chip as MuiChip } from "@mui/material";

import pages from "../../../constants/pages";
import { Chip, Paper } from "../../../components";
import { ActiveTextEighteen, colors } from "../../css components/Style";

export default function AdminBrandStatus({ formData, state }) {
  const navigate = useNavigate();
  return (
    <Paper>
      {formData.status === "REJECTED" && (
        <Grid size={12}>
          <ActiveTextEighteen color={colors.error}>
            The brand has been rejected.
          </ActiveTextEighteen>
        </Grid>
      )}

      {!formData.status && (
        <Grid size={12}>
          <ActiveTextEighteen color={colors.warning}>
            The brand is in pending state.
          </ActiveTextEighteen>
        </Grid>
      )}

      {formData.status === "APPROVE" && (
        <Grid size={12}>
          <ActiveTextEighteen color={colors.green}>
            The brand has been accepted.
          </ActiveTextEighteen>
        </Grid>
      )}

      <Grid size={12} style={{ display: "flex", gap: "10px" }}>
        {formData?.apiPartner && (
          <Chip
            background={colors.blue}
            label={`API Partner : ${
              formData.apiPartner?.replace(/_/g, " ") || "-"
            }`}
          />
        )}

        {formData?.platformSource && (
          <Chip
            label={`Platform Source - ${formData?.platformSource}`}
            background={colors.green}
          />
        )}

        {formData.agency?.agency_name && (
          <Tooltip title="View Agency Details">
            <MuiChip
              style={{
                color: colors.purple,
                background: colors.lightPurple,
              }}
              deleteIcon={
                <Visibility
                  style={{ marginLeft: "10px", color: colors.purple }}
                />
              }
              onDelete={() => {
                navigate(
                  pages.unverifiedAgenciesDetails.route +
                    "?agencyID=" +
                    formData.agency?.agency_id
                );
              }}
              label={`Agency - ${formData.agency?.agency_name}`}
              onClick={() =>
                navigate(
                  pages.unverifiedAgenciesDetails.route +
                    "?agencyID=" +
                    formData.agency?.agency_id
                )
              }
            />
          </Tooltip>
        )}

        <Tooltip title="View Campaigns">
          <MuiChip
            style={{
              color: colors.purple,
              background: colors.lightPurple,
            }}
            deleteIcon={
              <Visibility
                style={{ marginLeft: "10px", color: colors.purple }}
              />
            }
            onDelete={() => {
              const query = {
                agencyID: formData.agency?.agency_id,
                brandID: formData.brandID,
                platformID:
                  parseInt(formData.platformID) === 0 ? 0 : formData.platformID,
                accountType: formData.platformAssociationType
                  ? lowerCase(formData.platformAssociationType)
                  : undefined,
              };

              const params = new URLSearchParams(
                Object.entries(query).filter(
                  ([_, v]) => v !== undefined && v !== null
                )
              );

              const url = `${
                pages.superAdminAllCampaigns.route
              }?${params.toString()}`;
              navigate(url);
            }}
            label={`Total Campaigns - ${formData.TotalCampaign}`}
            onClick={() => {
              const query = {
                agencyID: formData.agency?.agency_id,
                brandID: formData.brandID,
                platformID:
                  parseInt(formData.platformID) === 0 ? 0 : formData.platformID,
                accountType: formData.platformAssociationType
                  ? lowerCase(formData.platformAssociationType)
                  : undefined,
              };

              const params = new URLSearchParams(
                Object.entries(query).filter(([_, v]) => v)
              );

              const url = `${
                pages.superAdminAllCampaigns.route
              }?${params.toString()}`;
              navigate(url);
            }}
          />
        </Tooltip>

        <Tooltip title="View Audiences">
          <MuiChip
            style={{
              color: colors.purple,
              background: colors.lightPurple,
            }}
            deleteIcon={
              <Visibility
                style={{ marginLeft: "10px", color: colors.purple }}
              />
            }
            onDelete={() => {
              const params = new URLSearchParams();

              if (formData.agency?.agency_id) {
                params.append("agencyID", formData.agency.agency_id);
              }

              if (formData.brandID) {
                params.append("brandID", formData.brandID);
              }

              const url = `${
                pages.superadminAudienceList.route
              }?${params.toString()}`;
              navigate(url);
            }}
            label={`Total Audiences - ${formData.TotalAudiences}`}
            onClick={() => {
              const params = new URLSearchParams();

              if (formData.agency?.agency_id) {
                params.append("agencyID", formData.agency.agency_id);
              }

              if (formData.brandID) {
                params.append("brandID", formData.brandID);
              }

              const url = `${
                pages.superadminAudienceList.route
              }?${params.toString()}`;

              navigate(url);
            }}
          />
        </Tooltip>
      </Grid>
    </Paper>
  );
}
